import * as Styles from './styles.tooltip';

type TooltipProps = {
    message: string;
    testId?: string;
};

const Tooltip = ({ message, testId }: TooltipProps) => {
  return (
    <Styles.Tooltip data-testid={testId}>
      {message}
    </Styles.Tooltip>
  );
};

export default Tooltip;
